<template>
  <div style="height: 100%">
    <div class="header-bar" data-langname="selection_slip">
      Selekcija za uplatu
    </div>
    <Slip />

    <div class="preferedBtns">
      <button
        @click="setBetFromPredefinedBtns(1)"
        class="default num-pre"
        data-numpad="predefined"
        :data-predefined="getGameConfig.CustomAmount1"
      >
        &nbsp;{{ getGameConfig.CustomAmount1 }}
      </button>
      <button
        @click="setBetFromPredefinedBtns(2)"
        class="default num-pre"
        data-numpad="predefined"
        :data-predefined="getGameConfig.CustomAmount2"
      >
        &nbsp;{{ getGameConfig.CustomAmount2 }}
      </button>
      <button
        @click="setBetFromPredefinedBtns(3)"
        class="default num-pre"
        data-numpad="predefined"
        :data-predefined="this.getGameConfig.CustomAmount3"
      >
        &nbsp;{{ getGameConfig.CustomAmount3 }}
      </button>
    </div>

    <div class="bet-bar-controls">
      <div class="bet-bar-controls-left">
        <div class="bet-bar-controls-row margin-bottom-10">
          <div class="bet-bar-box">
            <div class="title" data-langname="no_of_rounds">No of rounds</div>
            <div class="input-group gray">
              <div class="option down">
                <button @click="decreaseRounds"></button>
              </div>
              <div class="input">
                <input
                  type="number"
                  @keypress="onlyNumberWithoutDot"
                  @keyup="checkRoundsMax"
                  id="subscription-btn"
                  min="1"
                  max="10"
                  step="1"
                  :value="drawRounds"
                />
              </div>
              <div class="option up">
                <button @click="increaseRounds"></button>
              </div>
              <div class="clearfix"></div>
            </div>
          </div>
        </div>
        <div class="bet-bar-controls-row">
          <div class="bet-bar-box">
            <div class="title" data-langname="total_stake">TOTAL STAKE</div>
            <div class="input-group gray">
              <div class="option down">
                <button id="amount-down" @click="decreaseBetValue"></button>
              </div>
              <div class="input">
                <input
                  type="text"
                  id="betting-btn"
                  :value="
                    startingBetValue ? Number(startingBetValue).toFixed(2) : 0
                  "
                  :min="
                    getGameConfig.Bingo_MinBet
                      ? Number(getGameConfig.Bingo_MinBet).toFixed(2)
                      : 0
                  "
                  :max="
                    getGameConfig.Bingo_MaxBet
                      ? Number(getGameConfig.Bingo_MaxBet).toFixed(2)
                      : 0
                  "
                  :step="betValueStep ? Number(betValueStep).toFixed(2) : 0"
                  @keypress="onlyNumber"
                  @click="openNumpad"
                />
              </div>
              <div class="option up">
                <button id="amount-up" @click="increaseBetValue"></button>
              </div>
              <div class="clearfix"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="bet-bar-controls-right">
        <div class="bet-bar-box">
          <div class="button-group">
            <div class="stake-title max-stake" data-langname="maximum_stake_is">
              Maximum Stake
            </div>
            <button
              class="btn default max-stake max-bet"
              id="max-bet"
              @click="setBetValue(maxBetValue)"
            >
              {{ maxBetValue && maxBetValue.toFixed(2) }}
            </button>
            <div class="clearfix"></div>
          </div>
        </div>

        <div class="bet-bar-controls-row">
          <div class="bet-bar-box">
            <div class="button-group">
              <div
                class="stake-title min-stake"
                data-langname="minimum_stake_is"
              >
                Minimum stake
              </div>
              <button
                class="btn default min-stake"
                id="min-bet"
                @click="setBetValue(minBetValue)"
              >
                {{ minBetValue ? Number(minBetValue).toFixed(2) : 0 }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bet-bar-controls buy-row">
      <div class="bet-bar-controls-left left-buy-ticket-width">
        <div class="bet-bar-box">
          <button
            :class="
              disabledBuy
                ? 'btn buy-ticket disabled-grayscale'
                : 'btn buy-ticket'
            "
            id="buy-ticket-button"
            ref="lbBuyTicketButton"
            data-langname="buy_ticket"
            @click="buyTicket"
          >
            Buy Ticket
          </button>
        </div>
      </div>
      <div class="bet-bar-controls-right right-buy-ticket-width">
        <div class="right-buy-tiket-wrapper">
          <div
            class="betting-btn betting-btn-hover-red rubbish-btn"
            id="clear-bets"
            @click="clearAllBets"
          >
            <div class="rubish-icon"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import $eventBus from "../../eventBus";
import { translate } from "../../assets/common/lang";
import Slip from "./Slip";

export default {
  components: {
    Slip,
  },
  data() {
    return {
      minNumber: 1,
      maxNumber: 48,
      maxBetRounds: 10,
      startingBetValue: 1,
      minBetValue: 0,
      maxBetValue: 0,
      betValueStep: 0.5,
      drawRounds: 1,
      disabledBuy: true,
    };
  },
  methods: {
    setBetFromPredefinedBtns(e) {
      this.startingBetValue = this.getGameConfig["CustomAmount" + e];
      this.updateMinBet();
    },

    translate(word) {
      return translate(word);
    },
    randomSix(numbers) {
      this.$emit("randomSix", this.selectRandNumbers(numbers));
    },
    selectRandNumbers(range = 6) {
      let randNumbers = [];
      let counter = 0;
      while (counter < range) {
        const cycleRandNum = this.getRandomInt(this.minNumber, this.maxNumber);
        if (!randNumbers.includes(cycleRandNum)) {
          randNumbers.push(cycleRandNum);
          counter++;
        }
      }
      return randNumbers;
    },
    increaseRounds() {
      if (this.drawRounds + 1 >= 10) {
        this.drawRounds = 10;
      } else {
        this.drawRounds += 1;
      }
      this.updateMinBet();
    },
    quickLuckyBalls() {
      this.buyTicket();
    },
    decreaseRounds() {
      if (this.drawRounds - 1 <= 0) {
        this.drawRounds = 1;
      } else {
        this.drawRounds -= 1;
      }
      this.updateMinBet();
    },
    buyTicket() {
      if (!this.disabledBuy) {
        if (
          Number(Number(this.startingBetValue).toFixed(2)) <
          Number(Number(this.minBetValue).toFixed(2))
        ) {
          this.$bvToast.toast(
            `Minimalni iznos za kladjenje je ${Number(this.minBetValue).toFixed(
              2
            )}`,
            {
              title: translate("notification"),
              variant: "danger",
              autoHideDelay: 3000,
            }
          );
          this.$refs.lbBuyTicketButton.blur();
          this.$store.dispatch("setQuickReplayDisabled", false);
          return;
        }
        this.$refs.lbBuyTicketButton.blur();
        $eventBus.$emit("buyLuckyBallsTicket", {
          drawCount: this.drawRounds,
          betAmount: Number(Number(this.startingBetValue).toFixed(2)),
        });
      } else {
        this.$store.dispatch("setQuickReplayDisabled", false);
      }
    },
    setAllColors() {
      console.log("TEST setALL COLORS  ( setAllColors ");
      this.$emit("setAllColors");
    },
    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    openNumpad() {
      $eventBus.$emit("openNumpad");
    },
    setBetValue(value) {
      this.startingBetValue = value;
    },
    checkRoundsMax($event) {
      if (Number($event.target.value) > this.maxBetRounds) {
        $event.target.value = this.maxBetRounds;
        return;
      }
    },
    updateMinBet() {
      // IF ALL COLORS IN SLIP
      if (this.getSlip.some((item) => item.type === "ALLBALLS")) {
        this.minBetValue =
          Number(
            Number(this.getGameConfig.Bingo_MinBet) *
              Number(this.getMainCombinations)
          ) * this.drawRounds;
      } else {
        let betPerRound = 0;
        const minimumBet = this.getSlip.reduce((acc, obj) => {
          return acc + obj.minBetVal;
        }, 0);
        if (Number(minimumBet) < Number(this.getGameConfig.Bingo_MinBet)) {
          betPerRound = this.getGameConfig.Bingo_MinBet;
        } else {
          betPerRound = minimumBet;
        }
        this.minBetValue = betPerRound * Number(this.drawRounds);
      }

      if (this.minBetValue < Number(this.getGameConfig.Bingo_MinBet)) {
        this.minBetValue = Number(this.getGameConfig.Bingo_MinBet);
      }
      if (this.minBetValue > this.startingBetValue) {
        this.startingBetValue = this.minBetValue;
      }
      $eventBus.$emit("minBetValue", this.minBetValue);
    },
		updateMinBetReverse() {
      // IF ALL COLORS IN SLIP
      if (this.getSlip.some((item) => item.type === "ALLBALLS")) {
        this.minBetValue =
          Number(
            Number(this.getGameConfig.Bingo_MinBet) *
              Number(this.getMainCombinations)
          ) * this.drawRounds;
      } else {
        let betPerRound = 0;
        const minimumBet = this.getSlip.reduce((acc, obj) => {
          return acc + obj.minBetVal;
        }, 0);
        if (Number(minimumBet) < Number(this.getGameConfig.Bingo_MinBet)) {
          betPerRound = this.getGameConfig.Bingo_MinBet;
        } else {
          betPerRound = minimumBet;
        }
        this.minBetValue = betPerRound * Number(this.drawRounds);
      }

      if (this.minBetValue < Number(this.getGameConfig.Bingo_MinBet)) {
        this.minBetValue = Number(this.getGameConfig.Bingo_MinBet);
      }
      if (this.minBetValue < this.startingBetValue) {
        this.startingBetValue = this.minBetValue;
      }
      $eventBus.$emit("minBetValue", this.minBetValue);
    },
    decreaseBetValue() {
      this.startingBetValue = this.startingBetValue - this.betValueStep;
      const minimumBet = this.getSlip.reduce((acc, obj) => {
        return acc + obj.minBetVal;
      }, 0);
      if (Number(this.startingBetValue) < minimumBet) {
        this.startingBetValue = Number(minimumBet);
      } else {
        if (this.startingBetValue - this.betValueStep < this.minBetValue) {
          this.startingBetValue = this.minBetValue;
        }
      }
    },
    increaseBetValue() {
      console.log("test this.betValueStep ", this.betValueStep);
      if (this.startingBetValue + this.betValueStep > this.maxBetValue) {
        this.startingBetValue = this.maxBetValue;
      } else {
        this.startingBetValue += this.betValueStep;
      }
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    onlyNumberWithoutDot($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode == 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    clearAllBets() {
      this.$store.dispatch("setStartingBetCombinations", 1);
      this.$nextTick(() => (this.updateMinBet()));
      this.updateMinBet();
      this.updateMaxBetValue();
      $eventBus.$emit("clearBetsFromBetBar");
      this.drawRounds = 1;
    },
    clearFromEventAllBets() {
      this.$store.dispatch("setStartingBetCombinations", 1);
      this.$nextTick(() => (this.updateMinBet()));
      this.updateMinBet();
      this.updateMaxBetValue();
      this.drawRounds = 1;
    },
    updateMaxBetValue() {
      if (
        Number(this.getGameConfig.Bingo_MaxBet) >
        Number(this.getMainConfig.TerminalCredit)
      ) {
        this.maxBetValue = Number(this.getMainConfig.TerminalCredit);
      } else {
        this.maxBetValue = Number(this.getGameConfig.Bingo_MaxBet);
      }
    },
  },
  computed: {
    ...mapGetters([
      "getGameConfig",
      "getSelectedBalls",
      "getMainCombinations",
      "getMainConfig",
      "getSlip",
      "getStartingBetCombinations",
    ]),
  },
  watch: {
    drawRounds() {
      // console.log("tthis.drawRounds * this.getStartingBetCombinationss",this.drawRounds * this.getStartingBetCombinations)
      if (this.drawRounds * this.getStartingBetCombinations < this.minBetValue) {
        this.startingBetValue = this.minBetValue;
      } else {
        this.startingBetValue = this.drawRounds * this.getStartingBetCombinations;
      }
    },
    getStartingBetCombinations() {
      if (this.getStartingBetCombinations > this.startingBetValue)
        this.startingBetValue =
          this.getStartingBetCombinations * this.drawRounds;
    },
    getGameConfig() {
      if (!this.getGameConfig) {
        this.$bvToast.toast("There was an error communicating with API", {
          title: translate("notification"),
          variant: "danger",
          autoHideDelay: 3000,
        });
        return;
      } else {
        //this.startingBetValue = this.getGameConfig.Bingo_DefaultBet;
        this.startingBetValue =
          this.getStartingBetCombinations * this.drawRounds;
        this.minBetValue = this.getGameConfig.Bingo_MinBet;
        this.updateMaxBetValue();
        this.manualCombMinCombBet = this.getGameConfig.ManualCombMinCombBet;
        this.updateMinBet();
      }
    },
    getMainConfig() {
      this.updateMaxBetValue();
    },
    getMainCombinations() {
      if (Number(this.getMainCombinations) > 0) {
        this.disabledBuy = false;
      } else {
        this.disabledBuy = true;
      }
      this.updateMinBet({
        combinations: this.getMainCombinations,
        selectedBalls: this.getSelectedBalls,
      });
    },
  },
  mounted() {
		$eventBus.$on('minB', () => {
      this.updateMinBetReverse();
    });
    //this.$socket.emit("lb-get-statistics");
    //this.$socket.emit("get-game-config");
    $eventBus.$on("setBetFromNumpad", (betVal) => {
      this.setBetValue(betVal);
    });
    $eventBus.$on("buyQuickLuckyBalls", () => {
      this.quickLuckyBalls();
    });
    $eventBus.$on("buyTicketFromNumpad", (betVal) => {
      this.setBetValue(betVal);
      this.buyTicket();
    });
    $eventBus.$on("clearAllBets", () => {
      this.clearFromEventAllBets();
    });
    $eventBus.$on("luckyBallsReplayTicket", (data) => {
      this.$nextTick(() => {
        this.setBetValue(data.amount);
        this.updateMinBet();
        this.updateMaxBetValue();
      });
      this.drawRounds = data.roundsTotal;
    });
    this.disabledBuy = true;
  },
  beforeDestroy() {
    $eventBus.$off(`buyLuckyBallsTicket`);
    $eventBus.$off(`minBetValue`);
    $eventBus.$off(`luckyBallsReplayTicket`);
    $eventBus.$off("buyQuickLuckyBalls");
    $eventBus.$off("buyTicketFromNumpad");
  },
};
</script>
